import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Loader from 'components/Loader';
import ProductQuantity from './ProductQuantity';
import MaxQuantity from './MaxQuantity';
import PubSub from 'services/PubSub/';
import TooltipError from "components/TooltipError";
import CartAction from "actions/Cart"
import CartService from "services/Cart";
import TagManagerService from 'services/TagManager';
import StorageService from 'services/StorageService';
import PromotionQuantity from 'components/PromotionQuantity'
import useVariant from 'hooks/useVariant';
import RatingsStore from 'stores/new/Ratings';
import { exclusiveJumboID } from 'config'
import { ecommerce } from 'config/constants';
import SalesChannel from 'services/SalesChannel';
import { actionsType } from 'config/constants';
import style from './style.scss';//NOSONAR

const ProductControls = (props) => {
    const {qtyInit, callback, callbackAddToCart, store, addToList, variants, minimum, dropdownIsHidden} = props;

    const exclusiveVariante = useVariant(exclusiveJumboID);

    const [quantity, setQuantity] = useState(props.quantity || 0);
    const [loading, setLoading] = useState(false);
    const [actionError, setActionError] = useState(false);
    const [oldQty, setOldQty] = useState(0);
    const [timer, setTimer] = useState(null);
    const [id, setId] = useState(props.id);
    const [reviewData, setReviewData] = useState();
    const tagManagerData = props.config ? props.config.tagManagerData : null;
    const [showMax, setShowMax] = useState(false);
    const [config, setConfig] = useState({
        maxItems: 60,
        listButton: false,
        customClass: false,
        buyTitle: 'Agregar',
        listTitle: 'Guardar en una lista',
        id: props.id,
        addToCartCallback: callbackAddToCart ? callbackAddToCart : () => {}
    });

    const path = typeof window !== 'undefined' ? window.location.pathname : null;

    useEffect(() => {
        if(store && store.ratings && tagManagerData?.product?.productId) {
            tagManagerData.product.productId;
            let current = store.ratings.get(tagManagerData.product.productId);
            setReviewData(current ? current : null);
        }
    },[store])

    useEffect(() => {
        setQuantity(props.inCart || 0);
        setOldQty(props.quantity || 0);
    }, [props.inCart, props.quantity]);

    useEffect(() => {
        if (props.config) {
            props.config.buyTitle = props.config.buyTitle ? props.config.buyTitle : 'Agregar';
            props.config.listTitle = props.config.listTitle ? props.config.listTitle : 'Guardar en una lista';
            props.config.id = props.id;
            setConfig(props.config);
        }
    }, [props.config]);

    useEffect(() => {
        if(props.callbackLoading) {
            props.callbackLoading(loading);
        }
    }, [loading]);

    useEffect(() => {
        setId(props.id);
    }, []);

    const _removeCart = (value) => {
        if (value && (value.id === id)) {
            setQuantity(0);
            if(callback && (typeof callback === 'function')){
                callback(false);
            }
        }
    };

    const decrementQty = (event) => {
        let qty = quantity

        if (loading || (minimum && (qty <= minimum))) return false;

        qty--;

        if (qty < 1){
            qty = 0;
        } 

        if (qty === 0) {
            setLoading(true);
        }

        setQuantity(qty);
        clearTimeout(timer);
        setTimer(setTimeout(() => {
            setLoading(true);
            if (qty === 0) {
                if(callbackAddToCart) {
                    callbackAddToCart(id, qty);
                    setLoading(false)
                    return false;
                }
                const promise = CartAction.removeItem(id, oldQty);

                _removeCart({ promise, id: id });

                promise.then((orderForm) => {
                    setLoading(false);
                    setActionError(!orderForm || orderForm.isOld);
                    setOldQty(qty);
                    return orderForm;
                });


                if (tagManagerData) {
                    tagManagerData.product["ratings"] = reviewData.average.toFixed(1);
                    tagManagerData.product["reviews"] = reviewData.totalCount;
                    if(!props.pageSource) TagManagerService.productClick(tagManagerData.product, tagManagerData.listTitle, tagManagerData.position);
                    const itemProd = tagManagerData.product.items[0];
                    const productData = {
                        name: tagManagerData.product.productName,
                        id: itemProd.itemId,
                        refId: itemProd.referenceId[0].Value,
                        additionalInfo: { brandName: tagManagerData.product.brand },
                        quantity: props.inCart - qty,
                        ratings: tagManagerData.product.ratings,
                        reviews: tagManagerData.product.reviews
                    };

                    TagManagerService.removeCart(productData, itemProd.prices.regular, tagManagerData.listTitle);
                }
            } else {
                if(callbackAddToCart) {
                    callbackAddToCart(id, qty);
                    setLoading(false)
                    return false;
                }
                const promise = CartAction.updateItem(id, oldQty, oldQty  + (qty - props.inCart));

                promise.then((orderForm) => {
                    setLoading(false);
                    setActionError(!orderForm || orderForm.isOld);

                    return orderForm;
                });

                if (tagManagerData) {
                    tagManagerData.product["ratings"] = reviewData.average.toFixed(1);
                    tagManagerData.product["reviews"] = reviewData.totalCount;
                    if(!props.pageSource) TagManagerService.productClick(tagManagerData.product, tagManagerData.listTitle, tagManagerData.position);
                    if (qty <= oldQty) {
                        const itemProd = tagManagerData.product.items[0];
                        const productData = {
                            name: tagManagerData.product.productName,
                            id: itemProd.itemId,
                            refId: itemProd.referenceId[0].Value,
                            additionalInfo: { brandName: tagManagerData.product.brand },
                            quantity: props.inCart - qty,
                            ratings: tagManagerData.product.ratings,
                            reviews: tagManagerData.product.reviews
                        };


                        TagManagerService.removeCart(productData, itemProd.prices.regular, tagManagerData.listTitle);
                    }
                }
            }

            _sendEventOptimizer(tagManagerData.product);

        }, 1000));

        event.preventDefault();
    };

    const incrementQty = (event) => {
        if (loading || config.maxItems === 0) return false;
        
        let qty = quantity;

        qty++;

        setShowMax(false);
        if ((quantity) === config.maxItemsOrigin) {
            return false;
        }

        setQuantity(qty);
        clearTimeout(timer);
        setTimer(setTimeout(() => {
            setLoading(true);

            _validationModalNotes(props.item)
            if(callbackAddToCart) {
                callbackAddToCart(id, qty);
                setLoading(false)
                return false;
            }
            const promise = CartAction.updateItem(id, oldQty, oldQty  + (qty - props.inCart));
            promise.then((orderForm) => {
                setLoading(false);
                setActionError(!orderForm || orderForm.isOld);

                return orderForm;
            });

            tagManagerData.product["ratings"] = reviewData.average.toFixed(1);
            tagManagerData.product["reviews"] = reviewData.totalCount;
            if(tagManagerData){
                if(!props.pageSource) TagManagerService.productClick(tagManagerData.product, tagManagerData.listTitle, tagManagerData.position);
                TagManagerService.addToCart(tagManagerData.product, qty - props.inCart, tagManagerData.listTitle);
                _sendEventOptimizer(tagManagerData.product);
            }

        }, 1000));

        event.preventDefault();
    };
    const _validationModalNotes = (itemData) => {
        if(itemData){
            let productData = {
                id: itemData.itemId,
                name: itemData.name,
                imageUrl: itemData.images ? itemData.images[0].imageUrl : null,
                categories: tagManagerData ? tagManagerData.product.categories : null,
                'Variante': tagManagerData && tagManagerData.product['Variante'] ? tagManagerData.product['Variante'] : null
            }
            if(variants) Object.assign(productData, variants)
            CartService.dispatchModalNote(productData);
        }
    }

    const addToCart = (event) => {
        event.preventDefault();

        if (loading || config.maxItems === 0) return false;

        setLoading(true);
        const init  = qtyInit ? (qtyInit * 1) : 1;
        _validationModalNotes(props.item)
        const seller =  ecommerce.whiteLabel ? SalesChannel.getSeller() : '1';
        
        if(callbackAddToCart) {
            callbackAddToCart(id, init, seller);
            setLoading(false)
            setQuantity(init);
            setOldQty(init);
            return false;
        }

        const addItems = CartAction.addItems([{
            id: id,
            quantity: init,
            seller
        }]);

        addItems.then((orderForm) => {
            setQuantity(init);
            setOldQty(init);
            setActionError(!orderForm || orderForm.isOld);
            setLoading(false);

            const storeName = StorageService.getItem('store_name');

            if (!storeName || storeName === 'Jumbo Chile') {
                PubSub.dispatch('delivery_selector_open');
            }

            return orderForm;
        });

        tagManagerData.product["ratings"] = reviewData?.average ? reviewData?.average.toFixed(1) : null;
        tagManagerData.product["reviews"] = reviewData?.totalCount;

        if (tagManagerData) {
            if (!props.pageSource) {
                TagManagerService.productClick(tagManagerData.product, tagManagerData.listTitle, tagManagerData.position)
            }

            TagManagerService.addToCart(tagManagerData.product, init, tagManagerData.listTitle)
            TagManagerService.interaction(
                `click ${props && props.pageSource ? props.pageSource : 'PLP'}`,
                tagManagerData.product.categories[0],
                'Click: Agregar al carro'
            )

            if (reviewData && reviewData.average && reviewData.average > 0) {
                TagManagerService.interactionWithVariant(
                    `click ${props && props.pageSource ? props.pageSource : 'PLP'}`,
                    tagManagerData.product.categories[0],
                    'Click: Agregar al carro con Review'
                )
            }

            if (props.exclusiveJumbo) {
                TagManagerService.interactionWithVariant(
                    `click ${props && props.pageSource ? props.pageSource : 'PLP'}`,
                    tagManagerData.product.categories[0],
                    'Click: Agregar al carro Exclusivo Jumbo',
                    exclusiveVariante
                )
            }
            
            if (props.recommendedByCategory) {
                TagManagerService.interaction('PLP - Compra Juntos', path, 'RecommendationClick');
            }

            _sendEventOptimizer(tagManagerData.product)
        }
        if (
            callback && typeof callback === 'function') {
            callback(true)
        }
    };

    const _sendEventOptimizer = (product) => {
        if(product && product.item && product.item.promotionCat){
            TagManagerService.interaction(`${props && props.pageSource ? props.pageSource : 'PLP'}`, product.productName,  'Agregar al Carro precio TC');
        }
    }

    const openModalAddToList = (idSku) => {
        PubSub.dispatch(actionsType.DRAWER.ADDTO_LIST_OPEN, { skuId: idSku, config: config });
    };

    const clickOutTooltip = () => {
        if (!actionError) return false;
        setActionError(false);
    };

    const showMaxQuantity = (bool) =>{
        setShowMax(bool);
    }

    return (
        <div className={'product-control'}>
            {config.listButton && (
                <button onClick={() => openModalAddToList(id)} className="secundary-btn tooltip-container">
                    {config.listTitle}
                </button>
            )}
            <div className={`product-control-wrap ${!loading && quantity !== 0 ? 'product-control-wrap-quantity' : ''}`}>
                {!loading && quantity !== 0 && (
                    <div className={'product-change-quantity small' + (config.customClass ? ' small' : '')}>
                        <span className={'product-change-quantity-input'}>
                            <ProductQuantity
                                quantity={quantity}
                                item={config}
                                incrementQty={incrementQty}
                                decrementQty={decrementQty}
                                showMaxQuantity={showMaxQuantity}
                                oldQty={oldQty}
                                dropdownIsHidden={dropdownIsHidden}
                            />
                        </span>
                        <button
                            onClick={decrementQty}
                            className={`secundary-btn product-change-quantity-btn remove mobile-click ${quantity <= minimum ? 'disabled' : ''}`}>
                            <i className="font-icn minus" />
                        </button>
                        <button
                            onClick={incrementQty}
                            className={
                                'primary-btn product-change-quantity-btn add mobile-click' +
                                (quantity >= config.maxItemsOrigin || config.maxItems === 0 ? ' disabled-btn' : '')
                            }>
                            <i className="font-icn plus" />
                        </button>
                    </div>
                )}
                {!loading && quantity === 0 && (
                    <>
                        {addToList?.active && (
                            <button className="secundary-btn" onClick={() => openModalAddToList(id)}>
                                <span className="btn-span-register">Agregar a una lista</span>
                            </button>
                        )}
                        <button
                            className={
                                'primary-btn product-add-cart mobile-click' +
                                (config.customClass ? ' small ' : '') +
                                (config.maxItems === 0 ? ' disabled-btn ' : '')
                            }
                            onClick={addToCart}>
                            {actionError && (
                                <TooltipError message="En este momento no podemos completar tu solicitud." clickOut={clickOutTooltip} />
                            )}
                            <span className="product-add-cart-text">{config.buyTitle}</span>
                        </button>
                    </>
                )}
                {showMax ? (
                    <MaxQuantity
                        max={oldQty + config.maxItems}
                        unitMultiplier={config.unitMultiplier}
                        measurementUnit={config.measurementUnit}
                    />
                ) : (
                    props.item && <PromotionQuantity item={props.item} isLoading={loading} />
                )}
                {loading && (
                    <button className={'product-change-quantity-loader mobile-click '}>
                        <Loader />
                    </button>
                )}
            </div>
        </div>
    )
};

ProductControls.propTypes = {
    config: PropTypes.object,
    id: PropTypes.string,
    quantity: PropTypes.number,
    inCart: PropTypes.number,
    qtyInit: PropTypes.number,
    callback: PropTypes.func,
    callbackLoading: PropTypes.func,
    pageSource: PropTypes.string,
    addToList: PropTypes.object,
    recommendedByCategory: PropTypes.bool,
};

export default RatingsStore.wrapConsumer(ProductControls);
